"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "figline-e-incisa-valdarno": {
    "0ddf28d4": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "skipSearch": false
    }],
    "barberino": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "3d29ff1b": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "coop": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "052d0967": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "industriale-figline-valdarno": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "ef88005e": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "skipSearch": false
    }],
    "industriale-incisa-in-val-d-arno": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "2023a7e3": [{
      "hkey": "9f2e3547",
      "slug": "figline-e-incisa-valdarno",
      "name": "Figline e Incisa Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "loppiano": [{
      "hkey": "9f2e3547",
      "slug": "figline-e-incisa-valdarno",
      "name": "Figline e Incisa Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe70f03b": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "ospedale": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "08b01e1a": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-rosso": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "bb1f8e17": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "18c49912": [{
      "hkey": "9f2e3547",
      "slug": "figline-e-incisa-valdarno",
      "name": "Figline e Incisa Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "9f2e3547",
      "slug": "figline-e-incisa-valdarno",
      "name": "Figline e Incisa Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa97dc7f": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-figline-valdarno": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "29084525": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-incisa-in-val-d-arno": [{
      "hkey": "0eaf6dfc",
      "slug": "incisa-in-val-d-arno-centro",
      "name": "Incisa in Val d'Arno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "37376d74": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "stecco": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "8c75102e": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "via-petrarca": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }],
    "61489850": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "skipSearch": false
    }],
    "viale-a-monte": [{
      "hkey": "50d9c07d",
      "slug": "figline-valdarno-centro",
      "name": "Figline Valdarno centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "figline-e-incisa-valdarno"
    }]
  }
};
exports["default"] = _default;